import { render, staticRenderFns } from "./ManageUserThresholds.vue?vue&type=template&id=77804b56"
import script from "./ManageUserThresholds.vue?vue&type=script&lang=js"
export * from "./ManageUserThresholds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports